import {
  IconDashboardApplication,
  IconDocumentSignature,
  IconHomeOffice,
  IconPersonGear,
  IconWrench,
  SideMenu,
  SideMenuItem,
  IconHelp,
  IconUpload,
} from "@veneer/core";
import { SIDE_NAV } from "../../../constant";
import { useNavigate } from "react-router-dom";
import "./side-nav.css";
import useMediaQuery from "./custom-hook/mq-hook";
import { useTranslation } from "react-i18next";
import { closeBanner } from '@store/reducers/bannerSlice';
import { useAppDispatch } from '@store/hooks';
import { AdminRole } from "utils";

export const SideNav = () => {
  const dispatch = useAppDispatch();
  const pathname = window.location.pathname.replace("/en-US", "");
  const pathlist = [
    "/",
    "/create-case",
    "/my-cases",
    "/contract-warranties",
    "/profile",
    "/create-case/",
    "/my-cases/",
    "/contract-warranties/",
    "/profile/",
  ];
  if (pathname !== localStorage.getItem("current_path")) {
    if (pathlist.includes(pathname)) {
      localStorage.setItem("current_path", pathname);
    }
  }
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleNavigation = (path: string) => {
    dispatch(closeBanner());
    localStorage.setItem("current_path", path);
    navigate(path);
  };
  const isMdSize = useMediaQuery("(max-width: 992px)");

  const currePathActive = (path: string) => {
    const appLang = localStorage.getItem("current_path");
    return appLang === path;
  };


  return (
    <>
      <SideMenu
        appName={t('HPI.MainHomePage.MyHPSupport',{defaultValue:'My HP Support'})}
        logo={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 96 96"
            fill="#0096D6"
          >
            <defs>
              <path
                id="hpLogo"
                d="M48 96a49.7 49.7 0 0 1-1.426-.022l9.809-26.96h13.5c2.37 0 4.97-1.821 5.781-4.047L86.307 35.74c1.74-4.786-1-8.702-6.093-8.702H61.485L45.771 70.22h-.006l-8.909 24.478C15.721 89.672 0 70.673 0 48 0 25.981 14.827 7.427 35.04 1.772l-9.192 25.265h-.002L10.564 69.018l10.173.001 12.996-35.673h7.646L28.383 69.019l10.169.002 12.11-33.282c1.742-4.786-.999-8.702-6.087-8.702h-8.551L45.843.05C46.558.02 47.277 0 48 0c26.51 0 48 21.49 48 48S74.51 96 48 96Zm29.043-62.68h-7.644L58.697 62.688h7.643L77.043 33.32Z"
              />
            </defs>
            <use href="#hpLogo" />
          </svg>
        }
        logoUrl="./"
        position="fixed"
        showIcons
      
        size={isMdSize ? "small" : "large"}
        className="side-nav"
      >
        <SideMenuItem
          label={t("HPI.MainHomePage.SubmitnewCase.NewCase", {
            defaultValue: "Create a new case",
          })}
          selected={currePathActive("/")}
          onClick={() => handleNavigation("/")}
          icon={<IconWrench />}
        />
        <SideMenuItem
          onClick={() => handleNavigation("/my-cases")}
          selected={
            currePathActive("/my-cases") || currePathActive("/my-cases/")
          }
          label={t('HPI.MainHomePage.My Cases',{defaultValue:'My Cases'})}
          icon={<IconDashboardApplication />}
        />

        <SideMenuItem
          label={t("HPI.MainHomePage.UpperList.Contract", {
            defaultValue: "Contracts and warranties",
          })}
          icon={<IconDocumentSignature />}
          selected={
            currePathActive("/contract-warranties") ||
            currePathActive("/contract-warranties/")
          }
          onClick={() => handleNavigation("/contract-warranties")}
        ></SideMenuItem>
        <SideMenuItem
          label={t("HPI.PageNav.ProfileAndSettings", {
            defaultValue: "Profile and Settings",
          })}
          icon={<IconPersonGear />}
          selected={currePathActive("/profile") || currePathActive("/profile/")}
          onClick={() => handleNavigation("/profile")}
        />
        {AdminRole && (
          <SideMenuItem
            label={t("HPI.Profilepage.tab.Bulkupload",{defaultValue:'Bulk upload'})}
            icon={<IconUpload />}
            selected={currePathActive("/bulk-upload") || currePathActive("/bulk-upload/")}
            onClick={() => handleNavigation("/bulk-upload")}
          />
        )}
        <SideMenuItem label={t('HPI.MainHomePage.HelpLinks',{defaultValue:'Help Links'})} expanded icon={<IconHelp />}>
          <SideMenuItem
            label={t('HPI.MainHomePage.SupportHome',{defaultValue:'Support Home'})}
            onClick={() => window.open("https://support.hp.com", "_blank")}
            icon={<IconHomeOffice />}
          />
          <SideMenuItem
            label={t('HPI.MainHomePage.MyHPSupportHelp',{defaultValue:'MyHPSupport Help'})}
            onClick={() =>
              window.open(
                "https://support.hp.com/document/ish_9335347-9335391-16",
                "_blank"
              )
            }
            icon={<IconHomeOffice />}
          />
        </SideMenuItem>
      </SideMenu>
      
    </>
  );
};

